import { inject } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, exhaustMap, filter, map, mergeMap, of } from 'rxjs';

import { RefundBlueSageTransactionGQL } from 'src/generated/graphql.generated';

import { blueSageRefundLegsOf } from '../../bluesage/bluesage.util';
import { selectTransactionJob } from '../transaction-job.selectors';

import { CancelPreauthDialogActions } from './cancel-preauth-dialog.actions';
import { cancelPreauthDialogFeature } from './cancel-preauth-dialog.feature';

/** Void the selected authorization only after the operator confirms the row. */
export const cancelBlueSagePreauth = createEffect((
    actions$ = inject(Actions),
    store = inject(Store),
    refundGQL = inject(RefundBlueSageTransactionGQL),
) => {
    return actions$.pipe(
        ofType(CancelPreauthDialogActions.cancelPreauthConfirmed),
        exhaustMap((action) => of(action).pipe(
            concatLatestFrom(() => [
                store.select(cancelPreauthDialogFeature.selectTarget),
                store.select(selectTransactionJob),
            ]),
            filter(([ , target ]) => Boolean(target?.transactionId)),
            mergeMap(([ , target, job ]) => refundGQL.mutate({
                transactionId: target!.transactionId,
                reason: 'Authorization release',
            }).pipe(
                map(() => CancelPreauthDialogActions.cancelPreauthSuccess({
                    transactionId: target!.transactionId,
                    // Read BEFORE the mutation ran — the new leg can reach this
                    // browser over the job subscription before the response does.
                    knownLegIds: blueSageRefundLegsOf(job?.transactions, target!.transactionId)
                        .map((leg) => leg.id),
                })),
            )),
            catchError((error) => of(CancelPreauthDialogActions.cancelPreauthError({ error }))),
        )),
    );
}, { functional: true, dispatch: true });
